<template>
  <div>
    <div class="contentbottom-box">
      <div
        class="item"
        @toInfo="$emit('toInfo', item.id)"
        v-for="(item, index) in list"
        :key="index"
      >
        <div class="icon">
          <img :src="getImgUrl(item.thumb)" alt="" />
        </div>
        <div class="title">{{ item.title }}</div>
        <div class="text">{{ item.describe }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import url("./index.scss");
</style>
